/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserLoginResVo
 */
export interface UserLoginResVo {
    /**
     * 用户id
     * @type {number}
     * @memberof UserLoginResVo
     */
    id?: number;
    /**
     * 登录账号
     * @type {string}
     * @memberof UserLoginResVo
     */
    account?: string;
    /**
     * 用户编码
     * @type {string}
     * @memberof UserLoginResVo
     */
    code?: string;
    /**
     * 用户姓名 韩文
     * @type {string}
     * @memberof UserLoginResVo
     */
    name?: string;
    /**
     * 客户商业类型  1 企业 2 个人
     * @type {number}
     * @memberof UserLoginResVo
     */
    businessType?: number;
    /**
     * 钱包余额
     * @type {number}
     * @memberof UserLoginResVo
     */
    walletAmount?: number;
    /**
     * 无数据包裹数量
     * @type {number}
     * @memberof UserLoginResVo
     */
    nodataCount?: number;
    /**
     * 待支付订单数量
     * @type {number}
     * @memberof UserLoginResVo
     */
    unpaidOrderCount?: number;
    /**
     * 是否显示赠送金流水画面 0 隐藏，1 显示
     * @type {number}
     * @memberof UserLoginResVo
     */
    showCompensationMenu?: number;
    /**
     * token
     * @type {string}
     * @memberof UserLoginResVo
     */
    token?: string;
}

/**
 * Check if a given object implements the UserLoginResVo interface.
 */
export function instanceOfUserLoginResVo(value: object): value is UserLoginResVo {
    return true;
}

export function UserLoginResVoFromJSON(json: any): UserLoginResVo {
    return UserLoginResVoFromJSONTyped(json, false);
}

export function UserLoginResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLoginResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'account': json['account'] == null ? undefined : json['account'],
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'businessType': json['businessType'] == null ? undefined : json['businessType'],
        'walletAmount': json['walletAmount'] == null ? undefined : json['walletAmount'],
        'nodataCount': json['nodataCount'] == null ? undefined : json['nodataCount'],
        'unpaidOrderCount': json['unpaidOrderCount'] == null ? undefined : json['unpaidOrderCount'],
        'showCompensationMenu': json['showCompensationMenu'] == null ? undefined : json['showCompensationMenu'],
        'token': json['token'] == null ? undefined : json['token'],
    };
}

export function UserLoginResVoToJSON(json: any): UserLoginResVo {
    return UserLoginResVoToJSONTyped(json, false);
}

export function UserLoginResVoToJSONTyped(value?: UserLoginResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account': value['account'],
        'code': value['code'],
        'name': value['name'],
        'businessType': value['businessType'],
        'walletAmount': value['walletAmount'],
        'nodataCount': value['nodataCount'],
        'unpaidOrderCount': value['unpaidOrderCount'],
        'showCompensationMenu': value['showCompensationMenu'],
        'token': value['token'],
    };
}

